import React, { useCallback, useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import Dropdown from "../../Dropdown";
import axios from "../../../axios";
import { openModalAction } from "../../Modal/reducer";
import LoadingModal, { MODAL_EXPORT_LOADING } from "./LoadingModal";
import { handleExportDownload, handleExportError, prepareExportRequestParams } from "./methods";
import ExportOverlay, { EXPORT_TYPE_CSV, EXPORT_TYPE_PDF, EXPORT_TYPE_XLS } from "./ExportOverlay";

const ExportDropdown = (props) => {
  const { exportProps = {}, columns, tableService, selectedRows, className } = props;
  const allowedExportTypes = exportProps.exportTypes || [EXPORT_TYPE_XLS, EXPORT_TYPE_CSV, EXPORT_TYPE_PDF];
  const exportColumns = exportProps.columns;
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onExportClick = (type) => () => {
    const exportType = typeof type === "string" ? type : type.type;

    const exportParams = prepareExportRequestParams(
      type === EXPORT_TYPE_XLS ? exportProps.xlsColumns || exportColumns : exportColumns,
      columns,
      selectedRows
    );
    const filename = `${exportProps.filename || type}_export`;
    const params = {
      ...(tableService ? tableService.getFilters() : {}),
      ...exportParams,
      type: exportType,
      filename,
      ...exportProps?.params
    };

    // Custom export with screenshot image
    if (exportProps?.onCustomExport?.[exportType]) {
      exportProps.onCustomExport[exportType](params);
      setVisible(false);
      return;
    }

    dispatch(openModalAction({ name: MODAL_EXPORT_LOADING }));
    axios
      .get(exportProps.route, {
        params
      })
      .then(
        (res) => {
          handleExportDownload(res, dispatch, t);
        },
        () => handleExportError(dispatch, t)
      );

    setVisible(false);
  };

  const renderPopup = useCallback(
    () => <ExportOverlay allowedExportTypes={allowedExportTypes} onExportClick={onExportClick} />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allowedExportTypes]
  );

  return (
    <>
      <LoadingModal name={MODAL_EXPORT_LOADING} message={t("qam.loading_pdf_report_message")} />
      <Dropdown open={visible} onOpenChange={(vis) => setVisible(vis)} trigger={["click"]} popupRender={renderPopup}>
        <Button type="secondary" icon={<i className="ti-more" />} className={classNames("action-btn", className)}>
          {t("container.general_words.export")}
        </Button>
      </Dropdown>
    </>
  );
};

export default ExportDropdown;
